// extracted by mini-css-extract-plugin
export default {"container":"make-artwork_container__GnstX","greenButton":"make-artwork_greenButton__N7qz9"};